// @CED

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.btn-buy-now');
  if (!btn) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId;
  btn.disabled = true;
  btn.textContent = 'Loading...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then((res) => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => {
      window.location.href = '/checkout';
    })
    .catch((err) => {
      console.error('Buy Now error:', err);
      btn.disabled = false;
      btn.textContent = 'BUY NOW';
    });
});